import { AnyFactories, AnyModels } from 'miragejs/-types'
import { Server, Registry } from 'miragejs'

import { baseURL } from 'configs/api'
import { USERS_GET_ALL_SUCCESS_RESPONSE } from './data'
import { setResponse } from 'utils/mirage'

export function usersHandlers(
  server: Server<Registry<AnyModels, AnyFactories>>
) {
  server.get(
    `${baseURL}/teachers/v1alpha1/users`,
    setResponse(() => USERS_GET_ALL_SUCCESS_RESPONSE)
  )
}
